import { HttpEventType } from '@angular/common/http';
import { environment } from '@environment';
import { WizFile } from '@wizbii/models';
import { FileWebservice } from '@wizbii/webservices';
import { filter, map } from 'rxjs/operators';

export class UploadAdapter {
  private readonly loader;

  constructor(loader: any, private readonly fileWebservice: FileWebservice) {
    this.loader = loader;
  }

  async upload(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.loader.file.then((file: any) => {
        if (file.size > 3000000) {
          reject('Cette image est trop volumineuse.');
        }

        const wizFile = new WizFile({ name: file.name, domFile: file });

        this.fileWebservice
          .create(wizFile)
          .pipe(
            filter((e: any) => e.type === HttpEventType.Response),
            map((e: any) => e.body as WizFile)
          )
          .subscribe({
            next: (newFile) => {
              const imageUrl = `${environment.api.googleStorage}/${environment.wizbiiFiles}/${newFile.id}`;
              resolve({ default: imageUrl });
            },
          });
      });
    });
  }
}
